import { trans } from "./../helper/trans";
import { dimmer } from "../helper/dimmer";
import { notify } from "./../helper/notify";
import { humanDate } from "./../helper/humanDate";
import { buildFilter } from "./../helper/buildFilter";
import { processDateline } from "./../helper/processDateline";
import { adminPanel } from "./../helper/adminPanel";
import { fetchNews } from "./../helper/fetchNews";
import { updateCache } from "./../helper/updateCache";
import { manageTags } from "./../helper/manageTags";
import { request } from "./../helper/request";
import { buildReleaseEditor, toggleUpdate, releaseButton, newsButton } from "./../helper/buildReleaseEditor";

import { languages, pageNo, perPage, urlId, lang, relLang, sort, cachingServiceKeys } from "../app";
// some imports from our global scope
// 'lang' here is the lang attribute in the <head> tag

let newsContainer = $("#news_wrapper"),
	news = [],
	tags = {},
	count = 0,
	userLevel = "",
	author = "",
	admin = false;
// some top-level declarations

window.renderContent = async user => {
	if (relLang != "en") {
		$("html").attr("lang", relLang != "cn" ? relLang : "zh-Hans");
	}
	userLevel = user.userLevel;
	admin = userLevel.toLowerCase() === "admin" || userLevel.toLowerCase() === "qa";
	author = `${user.gacUser.firstname} ${user.gacUser.lastname}`;
	let params = {};
	if (urlId) {
		// presence of urlId indicates this is
		// a news release detail page so we're
		// just looking up a release by ID
		if (admin) {
			params = {
				reqId: "b7c12d03-b2a0-4334-adb7-71ecb15bcfec",
				urlId: urlId
			};
		} else {
			params = {
				reqId: "96003db9-6b8c-4ecb-823a-513dcaa001de",
				urlId: urlId,
				lang: lang,
				now: new Date().getTime()
			};
		}
	} else {
		// this is instead the index page; fetch recent
		// news releases meeting criteria depending on
		// user level
		const indProp = admin ? "index" : "aIndex";
		const start = (pageNo - 1) * perPage;
		const end = start + perPage - 1;
		params = {
			reqId: admin ? "c6148d32-343e-4918-b0fb-53982f7412e0" : "644bff17-8cd7-46ea-b103-8d98ac019eaa",
			datatype: "release",
			filter: `#langs.#lang.#index BETWEEN :start AND :end${!admin ? " AND #langs.#lang.#status = :true AND #langs.#lang.#pubTime <=  :now" : ""}`,
			namesAdd: {
				"#langs": "langs",
				"#lang": lang,
				"#index": indProp
			},
			valuesAdd: {
				":start": start,
				":end": end
			}
		};
		if (!admin) {
			params.namesAdd["#status"] = "status";
			params.namesAdd["#pubTime"] = "pubTime";
			params.valuesAdd[":now"] = new Date().getTime();
			params.valuesAdd[":true"] = true;
		}
	}
	try {
		const response = await fetchNews(
			{
				container: newsContainer,
				size: 1
			},
			news,
			urlId,
			params,
			userLevel
		);
		newsRouter(response, userLevel);
	} catch (err) {
		console.error("Error retrieving new releases");
	}
	// kick off news retrieval
};
// end renderContent function

const newsRouter = (response, userLevel) => {
	const countProp = userLevel === "admin" ? "count" : "aCount";
	if (response.type === "list") {
		news = response.data;
		count = news.length ? news[0].langs[lang][countProp] : 0;
		buildNewsSection(news, userLevel, author, sort);
	} else if (response.type === "single") {
		if (response.data && response.data != undefined) {
			count = response.data.langs[lang][countProp];
			showRelease(response.data, userLevel);
		} else {
			newsContainer.append(`<div class="uk-flex uk-flex-row uk-flex-middle uk-flex-center">
                    <div id="There was an error retrieving news release data.">${trans("We could not find that news release.")}</div>
                </div>`);
		}
	}
};

const showRelease = async (release, userLevel) => {
	let isNarrow = $(window).width() <= 800;
	let isSmall = $(window).width() <= 600;
	let values;
	if (release.langs[relLang] && (release.langs[relLang].status || userLevel.toLowerCase() != "guest")) {
		values = release.langs[relLang];
	} else {
		values = release.langs.en;
		notify(trans("This content currently is available in English only"), "info", "top-right", 5000);
	}
	// admins see inactive and active releases;
	// use english version if translation is not
	// available, but let user know in their lang

	$("head")
		.find("title")
		.html(`${trans("Gulfstream News")}: ${values.headline}`);

	newsContainer.html(`<div class="release_wrapper">
        <div class="headline_wrapper uk-margin-bottom uk-align-center">
            <div class="headline heading uk-heading-large uk-margin-remove">
                ${values.headline}${userLevel === "admin" ? ` <span class="pointer" data-id="${release.id}" id="edit_article_button" uk-icon="icon:pencil; ratio: 1.5"></span>` : ""}
            </div>
            ${values.subhead && values.subhead != "null" ? `<div class="subhead uk-margin-small-top">${values.subhead}</div>` : ""}
        </div>
        <div class="visuals_wrapper uk-margin-large ${values.images && values.images.length > 1 ? "uk-padding-remove-right" : ""}">
            ${
				!values.images || (values.images && !values.images.length)
					? "<!-- no visuals -->"
					: values.images && values.images.length === 1
					? (() => {
							let notVideo = !values.images[0].type || values.images[0].type.toLowerCase() != "video";
							return `<!-- single visual -->
                <div class="single_image_wrapper uk-image-1-1">
					${notVideo ? `<img alt="${values.images[0].name}" src="${isNarrow && values.images[0].preview ? values.images[0].preview : values.images[0].url}"/>` : values.images[0].video ? values.images[0].video.player.html : "Video not available"}
                </div>
                ${
					values.images[0].downloadable || !values.images[0].hasOwnProperty("downloadable")
						? `<div class="download_link">
                    <a class="underline" href="${notVideo ? values.images[0].url : `https://gulfstream.widen.net/download/gulfstream/${values.images[0].external_id}/${values.images[0].filename}?u=ozllfz`}" target="_blank">${trans(notVideo ? "Download high-resolution photo" : "Download video")}</a>
                </div>`
						: ""
				}`;
					  })()
					: values.images && values.images.length > 1
					? `<!-- multi image -->
                    <div class="image_wrapper" uk-slider="finite: true">
                        <div class="uk-position-relative">
                            <ul class="uk-slider-items">
                                ${values.images
									.map(image => {
										let notVideo = !image.type || image.type.toLowerCase() != "video";
										return `<li class="uk-width-1-1 uk-margin-small-bottom">
                                    <div class="uk-flex uk-flex-middle" style="height: 100%;">
                                        <div class="image_slide uk-width-1-1${notVideo ? "" : " video"}">
                                            ${notVideo ? `<img alt="${image.name}" src="${isNarrow && image.preview ? image.preview : image.url}"/>` : image.video ? image.video.player.html : "Video not available"}
                                        </div>
                                    </div>
                                    ${image.downloadable || !image.hasOwnProperty("downloadable") ? `<div class="download_link"><a class="underline" href="${notVideo ? image.url : `https://gulfstream.widen.net/download/gulfstream/${image.external_id}/${image.filename}?u=ozllfz`}" target="_blank">${trans(notVideo ? "Download high-resolution photo" : "Download video")}</a></div>` : ""}
                                </li>`;
									})
									.join("")}
                            </ul>
                        </div>
                        <ul class="uk-flex-center uk-dotnav uk-margin">
                            ${values.images
								.map(
									(image, index) => `<li tabindex="-1" uk-slider-item="${index}" ${index === 0 ? `class="uk-active"` : ""}>
                                        <a href tabindex="0"></a>
                            </li>`
								)
								.join("")}
                        </ul>
            
            
                    </div>`
					: ""
			}
        </div>
        <div class="body_wrapper uk-align-center">
            ${values.newsBody}
        </div>
        <div class="footer_wrapper uk-align-center">
            ${values.footer}
        </div>
        <div class="share_wrapper uk-align-center uk-margin-large uk-flex uk-flex-horizontal uk-flex-start uk-flex-middle">
            <span class="label bold heading uk-margin-small-right">${trans("Share")}</span>
            <a target="_blank" class="share facebook_share uk-icon-button uk-margin-small-right" uk-icon="icon: facebook; ratio: .8" data-id="${values.headline}" data-event="share" data-type="news release" data-method="Facebook"></a>
            <a data-id="${values.headline}" data-event="share" data-type="news release" data-method="Twitter" href="https://twitter.com/intent/tweet?text=${values.headline}&url=${location.href}&via=gulfstreamaero" target="_blank" class="share twitter-share-button uk-icon-button uk-margin-small-right" uk-icon="icon: twitter; ratio: .8"></a>
            <a data-id="${values.headline}" data-event="share" data-type="news release" data-method="LinkedIn" class="share linkedin_share uk-icon-button uk-margin-small-right" uk-icon="icon: linkedin; ratio: .8"></a>
            <a data-id="${values.headline}" data-event="share" data-type="news release" data-method="Email" href="mailto:?subject=${encodeURI(values.headline)}&body=${encodeURIComponent(values.headline)}%0D%0A%0D%0A${encodeURIComponent(values.summary)}%0D%0A%0D%0A${encodeURIComponent(humanDate(values.pubTime))}%0D%0A%0D%0A${encodeURIComponent(location.href)}%0D%0A%0D%0A" class="share uk-icon-button" uk-icon="icon: mail; ratio: .8"></a>
        </div>
        <hr/>
        <div class="related_wrapper">
            <div class="heading uk-text-center uk-margin-large uk-margin-large-top">${trans("related_news_releases")}</div>
            <div ${!isSmall ? "uk-grid" : ""} id="related_belt" class="uk-margin-large uk-padding-large uk-padding-remove-top uk-padding-remove-bottom ${!isSmall ? "uk-grid-small" : ""} ${isSmall ? "uk-padding-remove-right" : ""}">
                ${isSmall ? `<div class="related_slider" uk-slider></div>` : ""}
            </div>
        </div>
    </div>`);
	// add bulk of release

	$(".body_wrapper").find("p").eq(0).prepend(processDateline(values.dateline, values.pubTime, isSmall, true));
	// add formatted dateline to news body

	$(".share").on("click", function () {
		if (!window["ga-disable-UA-9583009-6"] && !window["ga-disable-G-CYL99NE5DN"]) {
			// google analytics not disabled
			if (typeof gtagEvent != "undefined") {
				gtagEvent($(this));
			}
		} else {
			console.error("click not tracked");
		}
	});
	// track icon clicks

	$("#edit_article_button").on("click", function (e) {
		e.preventDefault();
		$("#admin_wrapper").removeClass("hidden").find("#admin_controls").html(newsButton);
		releaseButton("cancel", [release], tags, newsRouter, author, userLevel, newsButton, $("#news_editor"), buildReleaseEditor);
		buildReleaseEditor([release], tags, $(this).attr("data-id"), lang, author, userLevel, newsRouter);
	});

	const createShareFile = () => {
		return new Promise(async (resolve, reject) => {
			const shareHead = `${values.headline.replace(/\s/g, "-").toLowerCase()}.html`;
			const params = {
				reqId: "aa835a5f-cbf9-42f3-bbf1-279c683458f2",
				shareHead: shareHead,
				headline: values.headline,
				summary: values.summary,
				ogImageTag: values.images && values.images.length ? `<meta property="og:image" content="${values.images[0].url}" />` : "",
				locale: lang === "en" ? "en_US" : lang === "cn" ? "zh" : lang,
				pubDate: humanDate(values.pubTime),
				redirectUrl: location.href
			};
			try {
				const response = await request(params);
				if (response.$metadata.httpStatusCode === 200) {
					resolve(`https://share.gulfstreamnews.com/${shareHead}`);
				} else {
					reject(response.data);
				}
			} catch (err) {
				reject(err);
			}
		});
	};
	// end createshareFile function

	$(".facebook_share").on("click", async function (e) {
		e.preventDefault();
		try {
			const response = await createShareFile();
			FB.ui(
				{
					method: "feed",
					link: response,
					app_id: "176671847111087"
				},
				// callback
				function (fbResponse) {
					// no-op
				}
			);
		} catch (err) {
			console.error("FB post error:", err);
		}
	});
	// fb share button click handler

	$(".linkedin_share").on("click", async function (e) {
		e.preventDefault();
		try {
			const response = await createShareFile();
			window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${response}`, "_blank", "width=500,height=500,titlebar=no,top=100,left=200");
		} catch (err) {
			console.error(err);
		}
	});
	// linkedin share button click handler

	/* set up tag and news search */
	$(".related_wrapper").append(dimmer(2));
	let firstPgNewsParams = {
		reqId: admin ? "c6148d32-343e-4918-b0fb-53982f7412e0" : "644bff17-8cd7-46ea-b103-8d98ac019eaa",
		datatype: "release",
		filter: `#langs.#lang.#index BETWEEN :start AND :end${!admin ? " AND #langs.#lang.#status = :true AND #langs.#lang.#pubTime <=  :now" : ""}`,
		namesAdd: {
			"#langs": "langs",
			"#lang": lang,
			"#index": admin ? "index" : "aIndex"
		},
		valuesAdd: {
			":start": 0,
			":end": 9
		}
	};
	if (!admin) {
		firstPgNewsParams.namesAdd["#status"] = "status";
		firstPgNewsParams.namesAdd["#pubTime"] = "pubTime";
		firstPgNewsParams.valuesAdd[":now"] = new Date().getTime();
		firstPgNewsParams.valuesAdd[":true"] = true;
	}
	let taggedNewsParams = {};
	const tagsExist = values.tags && values.tags.length;
	let tagFilter = [];
	if (tagsExist) {
		let valuesAdd = {
			":now": new Date().getTime()
		};
		taggedNewsParams = {
			reqId: "d93f8fb4-94e8-4c6d-ab7d-ca4cb19f3e5c",
			now: new Date().getTime(),
			lang: lang
		};
		values.tags.forEach((tag, index) => {
			valuesAdd[`:tag${index}`] = tag;
			tagFilter.push(`contains (#langs.#lang.#tags, :tag${index})`);
		});
		taggedNewsParams.valuesAdd = valuesAdd;
	}
	taggedNewsParams.filterAdd = tagFilter.length ? ` AND (${tagFilter.join(" OR ")})` : "";
	let related = [];
	const relatedRouter = (response, userLevel) => {
		related = related.concat(
			response
				.filter(item => item.langs[lang] && item.langs[lang].images && item.langs[lang].images.length && item.id != release.id && !related.filter(_item => _item.id === item.id).length)
				.sort((a, b) => {
					if (a.langs[lang].pubTime > b.langs[lang].pubTime) {
						return -1;
					} else if (a.langs[lang].pubTime < b.langs[lang].pubTime) {
						return 1;
					}
					return 0;
				})
				.splice(0, 3 - related.length)
		);
		// concats related[] with first 2 results of
		// fetchNews filtered for non-matching items with images,
		// sorted by pubTime and spliced

		presentRelated(related);
	};
	const tagRouter = async (response, userLevel) => {
		related = related.concat(
			response.data
				.filter(item => item.langs[lang] && item.langs[lang].images && item.langs[lang].images.length && item.id != release.id && !related.filter(_item => _item.id === item.id).length)
				.sort((a, b) => {
					if (a.langs[lang].pubTime > b.langs[lang].pubTime) {
						return -1;
					} else if (a.langs[lang].pubTime < b.langs[lang].pubTime) {
						return 1;
					}
					return 0;
				})
				.splice(0, 3)
		);
		if (related.length < 3) {
			// need a couple more items for the related
			// belt; lets just fetch the latest news
			try {
				const response = await fetchNews(
					{
						container: $(".related_wrapper"),
						size: 1
					},
					[],
					null,
					firstPgNewsParams,
					userLevel
				);
				relatedRouter(response.data, userLevel);
			} catch (err) {
				notify(trans("error"), "danger");
				console.error("Error fetching related news:", err);
			}
			// search for recent articles to flesh out the related
			// section
		} else {
			presentRelated(related);
		}
	};
	// end tagRouter fn

	if (tagsExist) {
		try {
			const response = await fetchNews(
				{
					container: $(".related_wrapper"),
					size: 1
				},
				[],
				null,
				taggedNewsParams,
				// these params use newsroomGetRelaseByTagPublic
				userLevel,
				true
			);
			tagRouter(response, userLevel);
		} catch (err) {
			console.error("Error fetching tag-matched related news:", err);
		}
		// search for related tags
	} else {
		// fetch recent news (public)
		try {
			const response = await fetchNews(
				{
					container: $(".related_wrapper"),
					size: 1
				},
				[],
				null,
				firstPgNewsParams,
				// these params use newsroomGetItemsPvt or newsroomGetItemsPublic
				userLevel
			);
			relatedRouter(response.data, userLevel);
		} catch (err) {
			console.error("Error fetching non-tag-matched related news:", err);
		}
		// search just for recent articles
	}

	function presentRelated(related) {
		if (isSmall) {
			$("#related_belt .related_slider").append(`<ul id="related_slider_items" class="uk-slider-items"></ul>`);
		}
		related.forEach(item => {
			let values = item.langs[lang];
			let imgUrl = values.images[0].customthumb ? values.images[0].customthumb : values.images[0].preview;
			let card = `<div class="card_wrapper uk-width-1-3@s uk-flex uk-flex-between uk-flex-column">
                <div class="related_thumb_details_wrapper">
                    <div class="related_thumb_wrapper uk-cover-container">
                        <a href="/${lang}/news/?id=${item.id}"><img uk-cover src="${imgUrl}"/></a>
                    </div>
                    <div class="related_headline heading uk-margin-small">
                        <a href="/${lang}/news/?id=${item.id}">${values.headline}</a>
                    </div>
                </div>
                <div class="related_link">
                    <a class="underline" href="/${lang}/news/?id=${item.id}">${trans("read_news_release")}</a>
                </div>
            </div>`;
			if (isSmall) {
				$("#related_slider_items").append(`<li class="related_slide">
                    ${card}
                </li>`);
			} else {
				$("#related_belt").append(card);
			}
			// for mobile, wrap items in
			// uk slider <ul></li> elements
		});
	}
};
// end showRelease function

const buildNewsSection = (news, userLevel, author, sort) => {
	const admin = userLevel === "admin";
	if (news.length) {
		// this is where news releases are listed

		newsContainer.html(`<div id="release_header" class="page-heading uk-heading-small uk-text-center uk-padding-large uk-padding-remove-top uk-margin-large uk-margin-remove-horizontal">${trans("News Releases")}</div>
        <div id="filter_wrapper"></div>
        <div id="showing_wrapper"></div>
        <div class="uk-margin-remove" id="list_wrapper"></div>
        <div id="pagination_wrapper" class="uk-margin-large-top">
            <ul class="uk-pagination uk-flex uk-flex-center uk-flex-middle">        
            </ul>
        </div>`);
		buildFilter(tags, $("#filter_wrapper"), userLevel);

		/* initialize filter handlers */

		let showingWrapper = $("#showing_wrapper");
		let listWrapper = $("#list_wrapper");
		let pageList = $("#pagination_wrapper ul");

		/* set up pagination */
		let linkStart = `/${lang}/news/?page=`;
		let numPages = Math.ceil(count / perPage);

		if (pageNo > 1) {
			pageList.append(`<li>
                <a href="${linkStart}${pageNo - 1}"><span uk-pagination-previous></span></a>
            </li>`);
		}
		// we need a previous button if we're past page 1

		let isActive = pageNo === 1;
		pageList.append(`<li>
            <a ${isActive ? `class="uk-active"` : ""} href="${linkStart}1"><span class="page ${isActive ? "active uk-flex uk-flex-center uk-flex-middle" : ""}">1</span></a>
        </li>`);
		// always have page 1

		if (numPages < 10) {
			// don't need our inactive elements
			for (let i = 2; i < numPages + 1; i++) {
				isActive = pageNo === i;
				pageList.append(`<li>
                    <a ${isActive ? `class="uk-active"` : ""} href="${linkStart}${i}"><span class="page ${isActive ? "active uk-flex uk-flex-center uk-flex-middle" : ""}">${i}</span></a>
                </li>`);
			}
		} else {
			// need at least one inactive separator
			if (pageNo < 6) {
				// don't need beginning separator
				for (let i = 2; i < 9; i++) {
					isActive = pageNo === i;
					pageList.append(`<li>
                    <a ${isActive ? `class="uk-active"` : ""} href="${linkStart}${i}"><span class="page ${isActive ? "active uk-flex uk-flex-center uk-flex-middle" : ""}">${i}</span></a>
                </li>`);
				}
				pageList.append(` <li class="uk-disabled"><span>...</span></li>
                <li>
                    <a ${pageNo === numPages ? `class="uk-active"` : ""} href="${linkStart}${numPages}"><span class="page ${pageNo === numPages ? "active uk-flex uk-flex-center uk-flex-middle" : ""}">${numPages}</span></a>
                </li>`);
			} else {
				// need at least beginning separator
				pageList.append(` <li class="uk-disabled"><span>...</span></li>`);

				for (let i = pageNo - 2; i < pageNo + 3; i++) {
					isActive = pageNo === i;
					if (i < numPages) {
						pageList.append(`<li>
                            <a ${isActive ? `class="uk-active"` : ""} href="${linkStart}${i}"><span class="page ${isActive ? "active uk-flex uk-flex-center uk-flex-middle" : ""}">${i}</span></a>
                        </li>`);
					}
				}
				if (pageNo < numPages - 3) {
					// need second separator
					pageList.append(` <li class="uk-disabled"><span>...</span></li>`);
				}
				pageList.append(`<li>
                    <a ${pageNo === numPages ? `class="uk-active"` : ""} href="${linkStart}${numPages}"><span class="page ${pageNo === numPages ? "active uk-flex uk-flex-center uk-flex-middle" : ""}">${numPages}</span></a>
                </li>`);
			}
		}
		if (pageNo < numPages) {
			pageList.append(`<li>
                <a href="${linkStart}${pageNo + 1}"><span uk-pagination-next></span></a>
            </li>`);
		}
		// we need a next button if we're not on last page

		news = news.sort((a, b) => {
			if (a.langs[lang].pubTime > b.langs[lang].pubTime) {
				return sort === "asc" ? 1 : -1;
			} else if (a.langs[lang].pubTime < b.langs[lang].pubTime) {
				return sort === "asc" ? -1 : 1;
			}
			return 0;
		});

		let now = new Date().getTime();

		showingWrapper.html(`<span>${trans("Showing")}</span>&nbsp;<span>${pageNo * 10 - 9}-${pageNo * 10 + (admin ? news.length : news.filter(item => item.langs[lang].status && item.langs[lang].pubTime <= now).length) - 10} ${trans("of")} ${count} ${trans("items")}</span>`);

		news.forEach(release => {
			if (admin || (release.langs[lang].status && release.langs[lang].pubTime <= now)) {
				let aPanel;
				if (admin) {
					aPanel = adminPanel(release);
				}
				// admins get metadata in their display, including which languages and tags are used

				let values = release.langs[lang];
				// for public user, we only want the values matching the selected language

				let releaseWrapper = `<div data-id="${release.id}" class="release_wrapper uk-padding-large uk-padding-remove-horizontal">
                    <div class="content_wrapper" uk-grid>
                        <div class="uk-width-1-1 uk-width-1-3@s">
                            <div class="pubDate heading bold">${humanDate(values.pubTime)}</div>
                            ${
								admin
									? `<div class="metadata_wrapper">
                                <div class="metadata_row">
                                    <span class="lang_wrapper">${aPanel.langs}</span>
                                </div>
                                <div class="metadata_row">
                                    <span class="metadata_label">Publish date past?</span> <span class="pubbed_wrapper">${aPanel.pubbed}</span>
                                </div>
								 <div class="metadata_row">
                                    <span class="metadata_label">Created/updated by:</span> <span class="editors_wrapper">${aPanel.editors}</span>
                                </div>
                                <div class="metadata_row">
                                    <span class="metadata_label">News feed?</span> <span class="feed_wrapper">${aPanel.feed}</span>
                                </div>
                                <div class="metadata_row">
                                    <span class="metadata_label">Sustainability feed?</span> <span class="sust_feed_wrapper">${aPanel["sust-feed"]}</span>
                                </div>
                        	    <div class="metadata_row">
                                    <span class="metadata_label">Featured?</span> <span class="featured_wrapper">${aPanel.featured}</span>
                                </div>
                                <div class="metadata_row">
                                    <span class="metadata_label">Active?</span> <span class="status_wrapper">${aPanel.status}</span>
                                </div>
                                <div class="metadata_row">
                                    <span class="metadata_label">"Dark" item?</span> <span class="status_wrapper">${aPanel.darkpage}</span>
                                </div>
                                <div class="metadata_row">
                                    <span class="metadata_label">Tags:</span> <span class="tags_wrapper">${aPanel.releaseTags}</span>
                                </div>                               
                            </div>`
									: ""
							}
                        </div>
                        <div class="uk-width-1-1 uk-width-2-3@s uk-margin-remove">
							${admin ? `<div class="uk-text-small">ID: ${release.id}</div>` : ""}
                            <div class="heading catLinks">${values.tags && values.tags.length ? `${trans("Categories")}: ${values.tags.map(tag => `<a href="/${lang}/search/?tag=${tag}">${tag}</a>`).join(", ")}` : ""}</div>
                            <div class="headline heading"><a href="/${lang}/news/?id=${release.id}">${values.headline}</a></div>
                            <div class="summary">${values.summary}</div>
                            <div class="read_more_link">
                                <a href="/${lang}/news/?id=${release.id}">${trans("Read News Release")}</a></span>${admin ? `<span data-button="edit button" class="edit_link"  uk-icon="icon: pencil; ratio: 1.2"></span>` : ""}
                            </div>

                        </div>    
                    </div>
            </div>`;
				// for admins, add pub date AND time, status, languages and tags;

				listWrapper.append(releaseWrapper);
			}
		});

		if (admin) {
			$("#admin_wrapper").removeClass("hidden");
			$("[data-button='edit button']").on("click", function (e) {
				e.preventDefault();
				buildReleaseEditor(news, tags, $(this).parents(".release_wrapper").attr("data-id"), lang, author, userLevel, newsRouter);
				// open news editor with this release (default to English)
			});
			// edit button click handler

			$("[data-more]").on("click", function (e) {
				e.preventDefault();
				const type = $(this).attr("data-type");
				switch (type) {
					case "pubbed":
						notify(`${languages[$(this).attr("data-lang")]} publish time: ${$(this).attr("data-more")}`, "primary", "top-right", 3000, "metadata", true);
						break;

					case "tags":
						notify(`${languages[$(this).attr("data-lang")]} tags: ${$(this).attr("data-more")}`, "primary", "top-right", 3000, "metadata", true);
						break;

					case "editors":
						const editData = $(this).attr("data-more").split(",");
						const lang = languages[$(this).attr("data-lang")];
						notify(`<div style="text-align: left !important;">${lang} creator:<br/>${editData[0]} (${humanDate(parseInt(editData[1]))})<br/><br/>Last ${lang} editor:<br/>${editData[2]} (${humanDate(parseInt(editData[3]))})</div>`, "primary", "top-right", 3000, "metadata", true);
						break;
				}

				// notify with additional data requested
			});

			$(".feed_wrapper, .sust_feed_wrapper, .featured_wrapper, .status_wrapper")
				.find("[data-toggle]")
				.on("click", async function (e) {
					e.preventDefault();
					try {
						await toggleUpdate($(this), news);
						buildNewsSection(news, "admin", author);
					} catch (err) {
						console.error(err);
						notify(err, "danger", "top-right", 3000, null, true);
					}
				});
			// for toggled metadata (news feed, featured, status), update with a click
		}
		// event handling for admins in metadata panel
	}
	if (admin && !$("[data-button='create news release']").length) {
		$("#admin_controls").append(newsButton);
		newsButton.show();
	}
	//  if this is an admin and there is no "create news
	// release" button already, add it

	if (admin && !$("[data-button='update cache']").length) {
		$("#admin_controls").append(`<button class="uk-button uk-button-primary uk-margin-small-left" data-button="update cache">Update Cache</button>`);
		$("[data-button='update cache']").on("click", async function (e) {
			e.preventDefault();
			try {
				await updateCache(cachingServiceKeys);
			} catch (err) {
				console.error("Cache update error:", err);
			}
		});
	}
	//  if this is an admin and there is no "create news
	// release" button already, add it

	if (admin && !$("[data-button='manage tags']").length) {
		$("#admin_controls").append(`<button class="uk-button uk-button-primary uk-margin-small-left uk-position-relative" data-button="manage tags">Manage Tags</button>`);
		$("[data-button='manage tags']").on("click", async function (e) {
			e.preventDefault();
			manageTags(tags, $(this));
		});
	}
	//  if this is an admin and there is no "create news
	// release" button already, add it

	releaseButton("create", news, tags, newsRouter, author, userLevel, newsButton, null, buildReleaseEditor);
	// instantiate click handler
};
// end buildNewsSection function
